import { MealType } from 'proto/Offer/MealType';

const mealTypeToUrlValueMap: Partial<Record<MealType, string>> = {
    [MealType.Breakfast]: 'breakfast',
    [MealType.AllInclusive]: 'allinclusive',
    [MealType.AllInclusivePlus]: 'allinclusivePlus',
    [MealType.FullBoard]: 'fullboard',
    [MealType.FullBoardPlus]: 'fullboardPlus',
    [MealType.HalfBoard]: 'halfboard',
    [MealType.HalfBoardPlus]: 'halfboardPlus',
    [MealType.None]: 'none',
};

const urlValueToMealTypeMap: Partial<Record<string, MealType>> =
    Object.fromEntries(
        Object.entries(mealTypeToUrlValueMap).map(([key, value]) => [
            value,
            key as MealType,
        ])
    );

export const convertMealTypeToUrlValue = (mealType: MealType) =>
    mealTypeToUrlValueMap[mealType];

export const convertUrlValueToMealType = (urlValue: string) =>
    urlValueToMealTypeMap[urlValue];
